import { Directive } from '@angular/core';

@Directive({
  selector: '[appModalTitleStyles]',
  host: {
    class: 'text-2xl font-bold text-text mb-1',
  },
})
export class ModalTitleStylesDirective {}
